import { useTranslation } from "react-i18next";
import CsvDataGrid from "./CsvDataGrid";

export default function HvacCsvDataGrid(props) {
    const { t } = useTranslation();
    const { points = [], pointApiStatusesByRowId = {}, components, componentsProps } = props;

    const dataColumns = [
        {
            field: "location",
            headerName: t("Location"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.location : null,
            csvFieldName: "location",
            dtoFieldName: "location",
        },
        {
            field: "name",
            headerName: t("Name"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.name : null,
            csvFieldName: "name",
            dtoFieldName: "name",
        },
        {
            field: "tariff",
            headerName: t("Tariff"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.tariff : null,
            csvFieldName: "tariff",
            dtoFieldName: "tariff",
        },
        {
            field: "set_point",
            headerName: t("Set Point"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.set_point : null,
            csvFieldName: "set_point",
            dtoFieldName: "set_point",
        },
        {
            field: "on_off",
            headerName: t("On/Off"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.on_off : null,
            csvFieldName: "on_off",
            dtoFieldName: "on_off",
        },
        {
            field: "mode",
            headerName: t("Mode"),
            flex: 1,
            minWidth: 120,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.mode : null,
            csvFieldName: "mode",
            dtoFieldName: "mode",
        },
        {
            field: "fan_speed",
            headerName: t("Fan Speed"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.fan_speed : null,
            csvFieldName: "fan_speed",
            dtoFieldName: "fan_speed",
        },
        {
            field: "temperature",
            headerName: t("Temperature"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.temperature : null,
            csvFieldName: "temperature",
            dtoFieldName: "temperature",
        },
        {
            field: "insulation",
            headerName: t("Insulation"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.insulation : null,
            csvFieldName: "insulation",
            dtoFieldName: "insulation",
        },
        {
            field: "capacity",
            headerName: t("Capacity"),
            flex: 1,
            minWidth: 120,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.capacity : null,
            csvFieldName: "capacity",
            dtoFieldName: "capacity",
        },
        {
            field: "floor_plan",
            headerName: t("Floor Plan"),
            flex: 1,
            minWidth: 150,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.floor_plan : null,
            csvFieldName: "floor_plan",
            dtoFieldName: "floor_plan",
        },
        {
            field: "display_on_floor_plan",
            headerName: t("Display on Floor Plan"),
            flex: 1,
            minWidth: 180,
            valueGetter: (p) => p.row.csvResult.success
                ? (p.row.csvResult.data.display_on_floor_plan ?? p.row.csvResult.data.display_on_floorplan)
                : null,
            csvFieldName: "display_on_floor_plan",
            dtoFieldName: "display_on_floor_plan",
        },
        {
            field: "automated",
            headerName: t("Automated"),
            flex: 1,
            minWidth: 120,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.automated : null,
            csvFieldName: "automated",
            dtoFieldName: "automated",
        },
        {
            field: "average_power_consumption_kw",
            headerName: t("Average Power Consumption (kW)"),
            flex: 1,
            minWidth: 220,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.average_power_consumption_kw : null,
            csvFieldName: "average_power_consumption_kw",
            dtoFieldName: "average_power_consumption_kw",
        },
        {
            field: "preheat_padding_hours",
            headerName: t("Preheat Padding (Hours)"),
            flex: 1,
            minWidth: 190,
            valueGetter: (p) => p.row.csvResult.success ? p.row.csvResult.data.preheat_padding_hours : null,
            csvFieldName: "preheat_padding_hours",
            dtoFieldName: "preheat_padding_hours",
        },
    ];

    return (
        <CsvDataGrid
            rowsData={points}
            apiStatusesByRowId={pointApiStatusesByRowId}
            dataColumns={dataColumns}
            components={components}
            componentsProps={componentsProps}
        />
    );
}
